import { ReactElement } from 'react';

import { WaitlistEntryCancelAppointmentCommand } from '@dreryk/egabinet-waitlist-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { AppointmentInvalidTransitionFault } from '@dreryk/egabinet-appointment-frontend-api';

import {
   dispatchSnackbarNegativeEvent,
   dispatchSnackbarPositiveEvent,
   ModalConfirmButton,
} from '@dreryk/react-components';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { translationKeys } from '../translations';

type VisitCancelNotConfirmedAndPatientRestoreModalConfirmButtonProps = {
   appointmentId: number;
   onSuccess?: VoidFunction;
};

export const VisitCancelNotConfirmedAndPatientRestoreModalConfirmButton = (
   props: VisitCancelNotConfirmedAndPatientRestoreModalConfirmButtonProps
): ReactElement => {
   const { executeAsync: cancelAndRestorePatient } = useCqrsCommand<void, void, AppointmentInvalidTransitionFault>(
      () => {
         const command = new WaitlistEntryCancelAppointmentCommand();
         command.appointmentId = AppointmentId.of(props.appointmentId);
         command.targetStatus = 'PENDING';
         return command;
      },
      {
         onFault: {
            'egabinet-appointment-frontend-api:AppointmentInvalidTransitionFault': () => {
               dispatchSnackbarNegativeEvent(translationKeys.visitAlreadyCancelled);
            },
         },
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyCancelledAndRestoredToWaitlist);
            props.onSuccess?.();
         },
      }
   );
   return (
      <ModalConfirmButton
         testId={'cancelAndRestore'}
         label={translationKeys.cancelAndRestore}
         onClick={cancelAndRestorePatient}
      />
   );
};
